import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const FaqPagination = ({ page, pageCount, onChange, from, to, total }) => {
  if (pageCount <= 1) return null;
  const pages = Array.from({ length: pageCount }, (_, i) => i + 1);
  const btn = 'min-w-[2.25rem] h-9 px-2 rounded-full text-sm font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <nav className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-8" aria-label="FAQ pages" data-testid="faq-pagination">
      <p className="text-sm text-[#3B3535]/60" data-testid="faq-pagination-summary">
        Showing {from}–{to} of {total}
      </p>
      <div className="flex items-center gap-1.5">
        <button type="button" data-testid="faq-page-prev" disabled={page === 1} onClick={() => onChange(page - 1)} className={`${btn} text-[#B5541B] hover:bg-[#B5541B]/10`} aria-label="Previous page">
          <ChevronLeft className="w-4 h-4 mx-auto" />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            data-testid={`faq-page-${p}`}
            aria-current={p === page ? 'page' : undefined}
            onClick={() => onChange(p)}
            className={`${btn} ${p === page ? 'bg-[#1F1E1E] text-white' : 'text-[#3B3535] hover:bg-[#B5541B]/10'}`}
          >
            {p}
          </button>
        ))}
        <button type="button" data-testid="faq-page-next" disabled={page === pageCount} onClick={() => onChange(page + 1)} className={`${btn} text-[#B5541B] hover:bg-[#B5541B]/10`} aria-label="Next page">
          <ChevronRight className="w-4 h-4 mx-auto" />
        </button>
      </div>
    </nav>
  );
};
